import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Pencil } from "lucide-react";
import { forwardRef } from "react";

interface Props {
  label: string;
  value: string;
  onClick?: () => void;
}

export const ReadOnlyInputEdit = forwardRef((props: Props) => {
  return (
    <div className="flex items-center justify-between">
      <div className="space-y-1">
        <Label className="text-md">{props.label}</Label>
        <p>{props.value}</p>
      </div>
      <Button size="icon" type="button" variant="ghost" onClick={props.onClick}>
        <Pencil className="h-4 w-4" />
      </Button>
    </div>
  );
});
